import type { LinkFragment } from '@seek/cmsu-cms-connect';

export const toUrl = (
  to: LinkFragment['to'],
  language: string = 'en',
  utmParameters = '',
): string => {
  const isNotEn = Boolean(language) && language !== 'en';
  switch (to?.__typename) {
    case 'ExternalUrl':
      // if the external url is a hash link, we don't want to append the utm parameters
      return utmParameters && to.externalUrl?.slice(0, 1) !== '#'
        ? to.externalUrl?.concat(`?${utmParameters}`) || '#'
        : to.externalUrl || '#';
    case 'Asset':
      return to.url;
    case 'Article':
      const articleSection = to.category?.relatedCategorySection?.sectionName;
      const articleParentSection =
        to.category?.relatedCategorySection?.parentSection?.sectionName;
      const articleCompleteSection = [articleParentSection, articleSection]
        .filter(Boolean)
        .join('/');
      // assuming hirer articles always have a section so the article without section is from candidate site
      const articlePath = articleSection
        ? `/${articleCompleteSection}/article/${to.slug}`
        : `/career-advice/article/${to.slug}`;
      return isNotEn ? `/${language}${articlePath}` : articlePath;
    case 'Page':
      const pageSection = to.relatedPageSection?.sectionName;
      const pageParentSection =
        to.relatedPageSection?.parentSection?.sectionName;
      const pageCompleteSection = [pageParentSection, pageSection]
        .filter(Boolean)
        .join('/');
      let pagePath = null;
      if (pageSection) {
        pagePath =
          pageSection === to.slug
            ? `/${pageCompleteSection}`
            : `/${pageCompleteSection}/${to.slug}`;
      } else {
        pagePath = `/page/${to.slug}`;
      }
      return isNotEn ? `/${language}${pagePath}` : pagePath;
    case 'Category':
      const categorySection = to.relatedCategorySection?.sectionName;
      const categoryParentSection =
        to.relatedCategorySection?.parentSection?.sectionName;
      const categoryCompleteSection = [categoryParentSection, categorySection]
        .filter(Boolean)
        .join('/');
      const categoryPath = `/${categoryCompleteSection}/category/${to.slug}`;
      return isNotEn ? `/${language}${categoryPath}` : categoryPath;
    default:
      return '#!';
  }
};
